const env = process.env.REACT_APP_ENV;
const ConfigUpselling =
{
    local: {
        "campania": {
            "key": "up-selling",
            "id": 409,
            "productCategory": "Upsell",
            "formaContactoDefault": 580,
            "canalVentaDefault": 578,
            "planes": [
                {
                    "pasate-a-duo":
                    {
                        "id": 4530,
                        "nombre": "Dúo Premium"
                    }
                },
                {
                    "pasate-a-triple":
                    {
                        "id": 4528,
                        "nombre": "Triple Premium"
                    }
                },
                {
                    "pasate-a-black":
                    {
                        "key": "pasate-a-black",
                        "id": 4529,
                        "nombre": "Black Familiar"
                    }
                }
            ]
        }
    },
    QA:
    {
        "campania": {
            "key": "up-selling",
            "id": 409,
            "productCategory": "Upsell",
            "formaContactoDefault": 580,
            "canalVentaDefault": 578,
            "planes": [
                {
                    "pasate-a-duo":
                    {
                        "id": 4530,
                        "nombre": "Dúo Premium"
                    }
                },
                {
                    "pasate-a-triple":
                    {
                        "id": 4528,
                        "nombre": "Triple Premium"
                    }
                },
                {
                    "pasate-a-black":
                    {
                        "key": "pasate-a-black",
                        "id": 4529,
                        "nombre": "Black Familiar"
                    }
                }
            ]
        }
    },
    PRE:
    {
        "campania": {
            "key": "up-selling",
            "id": 409,
            "productCategory": "Upsell",
            "formaContactoDefault": 580,
            "canalVentaDefault": 578,
            "planes": [
                {
                    "pasate-a-duo":
                    {
                        "id": 4632,
                        "nombre": "Dúo Premium"
                    }
                },
                {
                    "pasate-a-triple":
                    {
                        "id": 4633,
                        "nombre": "Triple Premium"
                    }
                },
                {
                    "pasate-a-black":
                    {
                        "key": "pasate-a-black",
                        "id": 4634,
                        "nombre": "Black Familiar"
                    }
                }
            ]
        }
    },
    PROD:
    {
        "campania": {
            "key": "up-selling",
            "id": 409,
            "productCategory": "Upsell",
            "formaContactoDefault": 580,
            "canalVentaDefault": 578,
            "planes": [
                {
                    "pasate-a-duo":
                    {
                        "id": 4632,
                        "nombre": "Dúo Premium"
                    }
                },
                {
                    "pasate-a-triple":
                    {
                        "id": 4633,
                        "nombre": "Triple Premium"
                    }
                },
                {
                    "pasate-a-black":
                    {
                        "key": "pasate-a-black",
                        "id": 4634,
                        "nombre": "Black Familiar"
                    }
                }
            ]
        }
    }
}

export default ConfigUpselling[env];